
jQuery(document).ready(function() {
  var token = localStorage.getItem('ys');
  if (!token) {
    jQuery.ajax({
      url: 'https://api.yotpo.com/oauth/token',
      method: 'post',
      data: {
        "client_id": "Z9jfTDCkDiMPGstYrUBX1MB2QyT6vNrJ6LAqLsDN",
        "client_secret": "IXG8kGfMNXCjqauU870S3ECUiZcgBNv2AOzmKCWo",
        "grant_type": "client_credentials"
      },
      success: function(res) {
        console.log(res);
        console.log(res.access_token);
        token = res.access_token;
        localStorage.setItem('ys', res.access_token);
      },
      error: function(err) {
        console.log(err);
      }
    });
  } else {
    console.log(token);
  }
  
  var pId = jQuery('section.yopto-new-design-section').attr('data-product-id');
  jQuery.ajax({
    url: "https://api-cdn.yotpo.com/v2/widget/Z9jfTDCkDiMPGstYrUBX1MB2QyT6vNrJ6LAqLsDN/products/" + pId + "/reviews.json?per_page=20&star=5",
    success: function(res) {
      var rev = res.response.reviews;
      if (rev.length > 0) {
        jQuery('#ySliderSectionId').fadeIn(500);
        var html = '';
        rev.forEach(function(v, k) {
          html += '<div class="yReviewContainer">';
          html += '<div class="yContent">';
          html += '<p class="yRev">' + v.content + '</p>';
          html += '<div class="yRating" data-rating="' + v.score + '">';
          for (var i = 1; i <= v.score; i++) {
            console.log(i);
            html += '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-labelledby="7373873676468-ada-star-ratings-text" width="15" height="15">' +
                    '<defs>' +
                    '<linearGradient aria-hidden="true" id="yotpo_stars_gradient_0.9954250864223815">' +
                    '<stop offset="100%" stop-color="rgba(174,31,36,1)"></stop>' +
                    '<stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>' +
                    '</linearGradient>' +
                    '</defs>' +
                    '<path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(174,31,36,1)" fill="url(\'#yotpo_stars_gradient_0.9954250864223815\')"></path>' +
                    '</svg>';
          }
          html += '</div>';
          html += '<p class="yAuthor">' + v.user.display_name + '</p>';
          html += '</div>';
          html += '<div class="yImage">';
          html += '<img src="' + (v.images_data ? v.images_data[0].original_url : 'https://cdn.shopify.com/s/files/1/0063/4218/0928/files/617840851-supplements-in-gym-bag-SQ.jpg?v=1718025718') + '">';
          html += '</div>';
          html += '</div>';
        });
        jQuery('#ySliderId').html(html);
        jQuery('.ySlider').slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      } else {
        jQuery('#ySliderId').html('<div class="noReview">No Reviews Found For This Product</div>');
      }
      console.log(res);
    },
    error: function(err) {
      console.log(err);
    }
  });
});
